// @flow
import React from 'react';
import BuildingsView from '../../components/BuildingsView';

function ForRent() {
  return (
    <div>
      <BuildingsView title="Propiedades en Arriendo" initialQuery={{ kindoffer: 1 }} />
    </div>
  );
}

export default ForRent;



// WEBPACK FOOTER //
// ./src/routes/ForRent/index.js